module.exports = "/assets/packs/images/0b1b342d44bfdab11e921f8a4a3fd3f2.png";